<script>
	import Editor from '../Commons/Editor'
	import {Form} from '../../helpers/Form/Form'

	export default {
		props: {
			successMessage: String
		},		
		components: {Editor},
		data() {
			return {
				type: 'manual',
				comment: {
					body: null
				},
				currentLocale: 'it',
				assigned: [],
				languages: [],
				fetch: new Form({
					state: 'enabled'
				}),
				form: new Form({
					id: null,
					current_locale: null,
					locale: null,
					translations: {
						body: {}
					},
					translatable: {
						body: null
					},
					translated_by: {}
				})
			}
		},
		computed: {
			filterLanguages() {
				return this.languages.filter(i => this.form.locale != i.code)
			},
		},
		watch: {
			'form.locale': {
				handler(val) {
					let translatedBy = this.form.translated_by
					translatedBy[val] = this.type
					
					this.$set(this.form, 'translated_by', translatedBy)						
				}
			}
		},		
		mounted() {
			this.initModal()

			this.$bus.$on('modal-translator.show', this.getData)
		},
		updated() {
			$(`.dropdown-trigger`).dropdown({
				alignment: 'right',
				coverTrigger: true,
				constrainWidth: false
			})
		},
		methods: {
			initModal() {
				let vm = this

				$(this.$refs.modal).modal({
					onCloseEnd: function() {
						vm.form.errors.clear()

						for (let prop in vm.form.translatable) {
							vm.$set(vm.form.translatable, prop, null)
						}						
					}
				})
			},
			switchLanguage(language = null) {
				if (language) {
					this.$set(this.form, 'locale', language.code)
				} else {
					language = {code: this.form.locale}
				}

				for (let prop in this.form.translatable) {
					this.$set(this.form.translatable, prop, this.form.translations[prop][language.code])
				}
			},	
			async getData({comment,type}) {
				this.$set(this, 'comment', comment)
				this.$set(this, 'type', type)

				await this.getLanguages()
				this.initComment(comment)
				this.switchLanguage()				

				$(this.$refs.modal).modal('open')		
			},
			initComment(comment) {
				let translations = comment.translations
				this.$set(this.form.translations, 'body', translations.body)
				if (Object.keys(comment.translated_by).length > 0) {
					this.$set(this.form, 'translated_by', comment.translated_by)	
				} else {
					let translatedBy = {}
					translatedBy[this.form.locale] = this.type

					this.$set(this.form, 'translated_by', translatedBy)	
				}

				this.languages.forEach(i => {
					if (!this.form.translations.body.hasOwnProperty(i.code)) {
						this.form.translations.body[i.code] = null
					}											
				})
			},
			async getLanguages() {
				let response = await this.fetch.get(route('api.deepl.languages'))
				let languages = response.languages.filter(i => i.language.toLowerCase() != response.currentLocale).map(i => {
					return {
						code: i.language.toLowerCase(),
						name: i.name
					}
				})

				this.$set(this, 'assigned', response.assigned)
				if (this.assigned.length > 0) {
					this.$set(this, 'languages', languages.filter(i => this.assigned.includes(i.code)))				
				} else {
					this.$set(this, 'languages', languages)			
				}

				let firstLang = _.head(this.languages)

				this.$set(this, 'currentLocale', response.currentLocale)
				this.$set(this.form, 'locale', firstLang.code)
				this.$set(this.form, 'current_locale', response.currentLocale)		
			},
			onSubmit() {
				this.refreshTranslations()

				this.form
					.submit('put', route('api.comments.update', this.comment.id))
					.then(response => {
						$(this.$refs.modal).modal('close')

						this.$swal({
							icon: 'success',
							text: this.successMessage
						})

						for (let prop in this.form.translatable) {
							this.$set(this.form.translatable, prop, null)
						}

						this.$bus.$emit('refresh-comments')
					})
			},
			onTranslate() {
				this.form
					.submit('post', route('deepl.translator'))
					.then(response => {
						let translations = response.translations
						for (let prop in translations) {
							this.$set(this.form.translatable, prop, translations[prop])
							this.$set(this.form.translations[prop], response.locale, translations[prop])
						}
					})
			},
			refreshTranslations() {
				for (let prop in this.form.translatable) {
					this.$set(this.form.translations[prop], this.form.locale, this.form.translatable[prop])
				}
			}
		}
	}
</script>